var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8561_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2769 39.3158L12.1738 59.5663L56.3311 56.5696L59.7318 12.0439L46.2766 39.3156L46.2769 39.3158Z",
    fill: "url(#paint0_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4029 56.5395L52.6075 30.3442L42.2695 43.9953L56.4029 56.5397V56.5395Z",
    fill: "url(#paint1_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4546 56.5395L28.6496 54.3569L12.3213 59.5094L56.4546 56.5395Z",
    fill: "url(#paint2_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3607 59.5149L19.3069 36.7593L4.02148 40.0273L12.3605 59.5147L12.3607 59.5149Z",
    fill: "url(#paint3_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.267 44.0702L35.8755 19.0356L17.585 36.1809L42.267 44.0706V44.0702Z",
    fill: "url(#paint4_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2821 19.3883L40.9923 5.26709L36.1777 20.8323L58.2821 19.3883Z",
    fill: "url(#paint5_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1968 0.231966L40.028 5.85175L33.6123 0.156738L50.1968 0.2322V0.231966Z",
    fill: "url(#paint6_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47.6608L4.25983 39.8918L0.813908 30.6362L0 47.6608Z",
    fill: "url(#paint7_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.584961 30.344L4.05198 40.1782L19.1169 36.7983L36.316 20.8138L41.17 5.39644L33.5272 0L20.5336 4.86282C16.4396 8.67059 8.49578 16.2046 8.2094 16.3461C7.92583 16.4909 2.96364 25.87 0.584961 30.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7588 12.6772C21.6314 3.88001 33.0695 -1.31747 37.4589 3.11133C41.846 7.54013 37.1936 18.3028 28.321 27.0971C19.4484 35.8912 8.15215 41.3751 3.76553 36.9463C-0.623899 32.5205 3.88622 21.4715 12.7588 12.6772Z",
    fill: "url(#paint8_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3604 59.5058L19.2522 36.6777L42.1403 44.0308C33.8648 51.7909 24.6606 58.3512 12.3604 59.5058Z",
    fill: "url(#paint9_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3467 20.769L42.2226 44.0433C49.1356 36.7746 55.3398 28.9603 58.3784 19.2949L36.3469 20.769H36.3467Z",
    fill: "url(#paint10_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3176 19.4121C60.6693 12.3154 61.2118 2.13443 50.1232 0.244141L41.0244 5.26984L58.3176 19.4121Z",
    fill: "url(#paint11_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47.5584C0.325751 59.2711 8.77605 59.4457 12.3757 59.5484L4.06087 40.1299L0 47.5584Z",
    fill: "#9E1209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3789 20.8054C41.691 24.0704 52.3969 30.6276 52.6139 30.748C52.9514 30.9379 57.2295 23.5337 58.2004 19.3491L36.3789 20.8054Z",
    fill: "url(#paint12_radial_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2432 36.6777L28.4563 54.4529C33.904 51.4984 38.1702 47.8988 42.0771 44.043L19.2432 36.6777Z",
    fill: "url(#paint13_radial_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02507 40.1543L2.71973 55.6984C5.18278 59.063 8.57152 59.3555 12.1257 59.0933C9.55416 52.6929 4.41691 39.8951 4.02507 40.1543Z",
    fill: "url(#paint14_linear_8561_1771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9707 5.30921L59.2737 7.87772C58.2966 3.73857 55.2969 1.06742 50.1838 0.232422L40.9707 5.30921Z",
    fill: "url(#paint15_linear_8561_1771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8561_1771",
    x1: 52.4792,
    y1: 64.9833,
    x2: 39.8925,
    y2: 42.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8561_1771",
    x1: 58.7562,
    y1: 46.2947,
    x2: 41.0627,
    y2: 42.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8561_1771",
    x1: 45.7629,
    y1: 65.6577,
    x2: 45.5349,
    y2: 54.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8561_1771",
    x1: 11.666,
    y1: 38.4054,
    x2: 16.9268,
    y2: 53.8315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8561_1771",
    x1: 28.9817,
    y1: 23.1284,
    x2: 29.9358,
    y2: 39.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8561_1771",
    x1: 44.3486,
    y1: 7.69434,
    x2: 45.7439,
    y2: 19.8205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8561_1771",
    x1: 35.8693,
    y1: 3.47955,
    x2: 37.8365,
    y2: -4.86199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8561_1771",
    x1: 1.17674,
    y1: 34.2344,
    x2: 6.3213,
    y2: 37.4591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF190B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8561_1771",
    x1: -5.59402,
    y1: 46.7609,
    x2: 40.6367,
    y2: -0.912804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8561_1771",
    x1: 29.8686,
    y1: 51.5628,
    x2: 16.7856,
    y2: 46.0678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8561_1771",
    x1: 53.822,
    y1: 34.8255,
    x2: 40.3457,
    y2: 25.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8561_1771",
    x1: 58.373,
    y1: 14.4518,
    x2: 52.0355,
    y2: 8.01842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E120B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_8561_1771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.362 23.9341) scale(15.1819 7.93307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0E08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_8561_1771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3369 43.9407) scale(20.182 15.7108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800E08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8561_1771",
    x1: 8.04069,
    y1: 59.4931,
    x2: -3.32189,
    y2: 50.0612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3100C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8561_1771",
    x1: 46.6208,
    y1: 2.95407,
    x2: 49.8459,
    y2: 11.1128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791C12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8561_1771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59.76,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.977fd41811f03207234372b817d1c8e8.svg";
export { ForwardRef as ReactComponent };